(function ($, settings) {
  Drupal.behaviors.esearchResultsPCV1 = {
    attached: false,

    /**
     * Initialize the filters
     */
    initFilterToggle: function ($results_container) {
      $('.js-end-filter-header', $results_container)
        .once()
        .click(function (e) {
          $(this).toggleClass('collapse').siblings('.js-end-filter-content').slideToggle('fast');
        });
    },
    attach: function (context, settings) {
      var self = this;

      // Only run this once
      if (self.attached) {
        return;
      }
      self.attached = true;

      var $results_container = $('.js-end-results-container', context);

      self.initFilterToggle($results_container);

      // Add a class so we know search page is loaded
      $('body').addClass('search-page--loaded');
    }
  };

  $(document).on('endeca.search.results.loaded', function (event, data) {
    var productData = data.results.products.resultData || {};

    console.log('productData');
    console.log(productData);

    // Set a context so that we're not targeting the entire page a second time
    var $c = $('.js-end-results');

    // If there are no product results, then show the no-results layer
    if (productData.length == 0) {
      $('.js-end-summary', $c).show();
      // return;
    } else {
      // Add the product data to the data store
      prodcat.data.updateProducts(productData, false);
    }

    // Initialize the prodcat UI stuff
    if (prodcat.ui && prodcat.ui.init) {
      prodcat.ui.init($c);
    }

    // Now that the product grid JS is in a behavoir, we can just reattach everything with a new context
    Drupal.attachBehaviors($c, settings);

    if (typeof site.l2Request !== 'undefined') {
      site.l2Request.params = site.l2Request.getParams();
      generic.jsonrpc.fetch(site.l2Request);
    }

    // Initialize some UI stuff for product grids
    // $(window).trigger('load.productGrid');
  });
})(jQuery, Drupal.settings);
